
import Vue from 'vue';

const AMETHYST: string = '#c2a4ec';
const VISTA: string = '#b6b9f7';

interface AmbientMote {
	icon: string;
	size: number;
	opacity: number;
	color: string;
	top: number;
	left?: string;
	right?: string;
	rotate?: number;
}

export default Vue.extend({
	name: 'HelpCenterAmbientBg',
	data () {
		return {
			// Mirrored down both gutters, densest at the top and thinning out as the
			// page scrolls, so the heading reads against texture and the FAQ against
			// near-flat black.
			motes: [
				// Left gutter
				{ icon: 'mdi-lightbulb-on-outline', size: 40, opacity: 0.18, color: AMETHYST, top: 18, left: '20px', rotate: -6 },
				{ icon: 'mdi-help-circle-outline', size: 26, opacity: 0.14, color: VISTA, top: 34, left: '104px' },
				{ icon: 'mdi-message-outline', size: 24, opacity: 0.13, color: VISTA, top: 104, left: '44px', rotate: 8 },
				{ icon: 'mdi-crown-outline', size: 20, opacity: 0.09, color: AMETHYST, top: 126, left: '150px' },
				{ icon: 'mdi-school-outline', size: 30, opacity: 0.10, color: AMETHYST, top: 196, left: '26px' },
				{ icon: 'mdi-message-processing-outline', size: 22, opacity: 0.06, color: VISTA, top: 242, left: '126px', rotate: -10 },
				{ icon: 'mdi-help-circle-outline', size: 24, opacity: 0.055, color: VISTA, top: 330, left: '52px' },
				{ icon: 'mdi-lightbulb-on-outline', size: 20, opacity: 0.035, color: AMETHYST, top: 452, left: '22px' },
				{ icon: 'mdi-school-outline', size: 22, opacity: 0.025, color: AMETHYST, top: 640, left: '30px' },
				// Right gutter
				{ icon: 'mdi-message-processing-outline', size: 38, opacity: 0.18, color: VISTA, top: 22, right: '24px', rotate: 7 },
				{ icon: 'mdi-crown-outline', size: 24, opacity: 0.14, color: AMETHYST, top: 44, right: '112px' },
				{ icon: 'mdi-school-outline', size: 26, opacity: 0.13, color: AMETHYST, top: 112, right: '40px', rotate: -8 },
				{ icon: 'mdi-lightbulb-on-outline', size: 20, opacity: 0.09, color: VISTA, top: 134, right: '154px' },
				{ icon: 'mdi-message-outline', size: 30, opacity: 0.10, color: VISTA, top: 204, right: '28px' },
				{ icon: 'mdi-help-circle-outline', size: 22, opacity: 0.06, color: AMETHYST, top: 250, right: '132px', rotate: 9 },
				{ icon: 'mdi-crown-outline', size: 24, opacity: 0.055, color: AMETHYST, top: 338, right: '56px' },
				{ icon: 'mdi-message-processing-outline', size: 20, opacity: 0.035, color: VISTA, top: 462, right: '24px' },
				{ icon: 'mdi-lightbulb-on-outline', size: 22, opacity: 0.025, color: VISTA, top: 660, right: '32px' },
				// A pair drifting in over the heading itself, faint enough to stay behind the type
				{ icon: 'mdi-crown-outline', size: 20, opacity: 0.07, color: VISTA, top: 16, left: '24%', rotate: -5 },
				{ icon: 'mdi-message-outline', size: 22, opacity: 0.07, color: AMETHYST, top: 30, right: '26%' },
			] as AmbientMote[],
		};
	},
	methods: {
		moteStyle (mote: AmbientMote): Record<string, string> {
			return {
				top: `${mote.top}px`,
				...(mote.left ? { left: mote.left } : {}),
				...(mote.right ? { right: mote.right } : {}),
				opacity: `${mote.opacity}`,
				// v-icon sets its own colour, so the override has to win the cascade.
				color: mote.color,
				...(mote.rotate ? { transform: `rotate(${mote.rotate}deg)` } : {}),
			};
		},
	},
});
